module.exports = __webpack_public_path__ + "public/img/ico-phone.bb835ae3.svg";